import { reload_order_list_all } from "./OrderConn";
import { search_dlv_Maninfo, search_dlv_store_info } from "./dlvCommonConn";
import { Fn_activeAxios } from "../function/FnConfig";
import { fn_bridge_quickaddr_set, fn_bridge_shopinfo_change_set, fn_bridge_text_notify } from "../function/FnPosBridge";
import {
  fn_newNoticeList,
  fn_detailNoticeList,
  fn_setKitchenPrinterFlag,
  fn_setHookingFlag,
  fn_setReturnListInit,
  fn_ygy_holiday_setting,
} from "function/FnBodySetting";

// 매장 기본정보 조회 todo 멀티포스 설정값
export async function select_shop_setting(rootStore) {
  rootStore.settingStore.setSettingDefaultViewObj(
    "viewType",
    rootStore.searchStore._st_session.viewType == null ? "list" : rootStore.searchStore._st_session.viewType
  );
  rootStore.settingStore.setSettingDefaultViewObj(
    "viewOrder",
    rootStore.searchStore._st_session.viewOrder == null ? "asc" : rootStore.searchStore._st_session.viewOrder
  );
  rootStore.settingStore.setSettingDefaultViewObj(
    "deliveryDfTime",
    rootStore.searchStore._st_session.deliveryDfTime == null ? "60" : rootStore.searchStore._st_session.deliveryDfTime
  );
  rootStore.settingStore.setSettingDefaultViewObj(
    "cookingDfTime",
    rootStore.searchStore._st_session.cookingDfTime == null ? "10" : rootStore.searchStore._st_session.cookingDfTime
  );
  rootStore.settingStore.setSettingDefaultViewObj(
    "pickupDfTime",
    rootStore.searchStore._st_session.pickupDfTime == null ? "10" : rootStore.searchStore._st_session.pickupDfTime
  );
  rootStore.settingStore.setSettingDefaultViewObj(
    "autoAcceptFlag",
    rootStore.searchStore._st_session.autoAcceptFlag == null ? "N" : rootStore.searchStore._st_session.autoAcceptFlag
  );
  rootStore.settingStore.setSoundPlayInfo(rootStore.searchStore._st_session.soundSetting);
  rootStore.settingStore.setManagerSettingFlag(rootStore.searchStore._st_session.managerSetting);
  rootStore.settingStore.setLoginInfo(rootStore.searchStore._st_session.login);
  rootStore.settingStore.setInitView(rootStore.searchStore._st_session.initView);
  rootStore.settingStore.setKitchenPrintYn(rootStore.searchStore._st_session.kitchenPrintYn);
  rootStore.settingStore.setPrinterInfo(rootStore.searchStore._st_session.printerSetting);
  rootStore.settingStore.setEtcPrinterInfo(rootStore.searchStore._st_session.etcPrintSettings);
  rootStore.settingStore.setKioskOrderYn(rootStore.searchStore._st_session.kioskOrderYn);
  rootStore.settingStore.setPosOrderYn(rootStore.searchStore._st_session.posOrderYn);
  rootStore.settingStore.setDcOrderYn(rootStore.searchStore._st_session.dcOrderYn);
  rootStore.settingStore.setPosType(rootStore.searchStore._st_session.posType);
  rootStore.settingStore.setProgressingExposeFlag(rootStore.searchStore._st_session.progressingExposeFlag);
  rootStore.settingStore.setAlarmTalkYn(rootStore.searchStore._st_session.alarmTalkYn);
  rootStore.settingStore.setPosAlarmtalkYn(rootStore.searchStore._st_session.posAlarmtalkYn);
  rootStore.settingStore.setPagerBellYn(rootStore.searchStore._st_session.pagerBellYn);
  rootStore.settingStore.setQrAlarmtalkYn(rootStore.searchStore._st_session.qrAlarmtalkYn);
  rootStore.settingStore.setMainPosType(rootStore.searchStore._st_session.mainPosYn);
}

// 매장 설정정보 api조회
export async function select_shop_setting_api(rootStore, data, type) {
  let comPortsLoadShop = rootStore.searchStore._st_session.printerSetting.availableComPorts;

  rootStore.settingStore.setInitView(data.initView);
  rootStore.settingStore.setSettingDefaultViewObj("viewType", data.viewType == null ? "list" : data.viewType);
  rootStore.settingStore.setSettingDefaultViewObj("viewOrder", data.viewOrder == null ? "asc" : data.viewOrder);
  rootStore.settingStore.setSettingDefaultViewObj(
    "deliveryDfTime",
    data.deliveryDfTime == null ? "60" : data.deliveryDfTime
  );
  rootStore.settingStore.setSettingDefaultViewObj(
    "cookingDfTime",
    data.cookingDfTime == null ? "10" : data.cookingDfTime
  );
  rootStore.settingStore.setSettingDefaultViewObj("pickupDfTime", data.pickupDfTime == null ? "10" : data.pickupDfTime);
  rootStore.settingStore.setSoundPlayInfo(data.soundSetting);
  rootStore.settingStore.setManagerSettingFlag(data.managerSetting);
  rootStore.settingStore.setProgressingExposeFlag(data.progressingExposeFlag);

  if (type == "rabbit") {
    rootStore.settingStore.setPrinterInfo(data.printerSetting);
    rootStore.settingStore.setEtcPrinterInfo(data.etcPrintSettings);
    fn_bridge_shopinfo_change_set(rootStore);
  }

  //장치관리자
  rootStore.settingStore.setPrinterInfoAvailableComPorts(comPortsLoadShop);
}

// 매장 기본정보 조회
export function update_shop_view_order(rootStore) {
  const searchStore = rootStore.searchStore;
  const settingStore = rootStore.settingStore;

  let data = JSON.stringify({
    shopCd: searchStore.getShopCd,
    viewType: settingStore.getOrderViewType,
    viewOrder: settingStore.getOrderViewOrder,
    //soundLevel : settingStore.getSoundLevel,
    deliveryDfTime: settingStore.getDeliveryDfTime,
    cookingDfTime: settingStore.getCookingDfTime,
    autoAcceptDelivery: settingStore.getAutoAcceptDelivery,
    autoAcceptPickup: settingStore.getAutoAcceptPickup,
    autoAcceptTable: settingStore.getAutoAcceptTable,
  });

  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/update_shop_view_order", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data) {
            reload_order_list_all(rootStore); // 주문 목록 조회
          }
        }
      }
    })
    .catch(err => {});
}

// 매장 기본정보 조회
export function select_quick_addr(rootStore) {
  const searchStore = rootStore.searchStore;
  const settingStore = rootStore.settingStore;

  let data = JSON.stringify({ shopCd: searchStore.getShopCd });

  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/select_quick_addr", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data) {
            settingStore.setQuickAddr(data);
          }
        }
      }
    })
    .catch(err => {});
}

// 퀵주소 등록
export function insert_quick_addr(rootStore) {
  const searchStore = rootStore.searchStore;
  const settingStore = rootStore.settingStore;

  let data = JSON.stringify({
    shopCd: searchStore.getShopCd,
    addr: settingStore.getQuickAddrCurr,
  });

  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/insert_quick_addr", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      settingStore.setQuickAddrCurr("");

      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data) {
            settingStore.setQuickAddr(data);
          }
          fn_bridge_quickaddr_set(rootStore);
        }
      }
    })
    .catch(err => {});
}

// 퀵주소 삭제
export function delete_quick_addr(rootStore, seq) {
  const searchStore = rootStore.searchStore;
  const settingStore = rootStore.settingStore;

  let data = JSON.stringify({
    shopCd: searchStore.getShopCd,
    seq: seq,
  });

  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/delete_quick_addr", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data) {
            settingStore.setQuickAddr(data);
            fn_bridge_quickaddr_set(rootStore);
          }
        }
      }
    })
    .catch(err => {});
}

// 자체 배달원
export async function delivery_man_info(rootStore, state) {
  const searchStore = rootStore.searchStore;
  const formData = rootStore.deliveryStore.getDeliveryAspForm;
  let data = JSON.stringify(
    formData.actionFlag === "C"
      ? {
          actionFlag: formData.actionFlag,
          empNm: formData.empNm,
          empPw: formData.empPw,
          retireFlag: formData.retireFlag,
          shopCd: searchStore.getShopCd,
        }
      : {
          actionFlag: formData.actionFlag,
          empNm: formData.empNm,
          empNo: formData.empNo,
          retireFlag: formData.retireFlag,
          shopCd: searchStore.getShopCd,
        }
  );

  const api = Fn_activeAxios(rootStore);
  let res = await api
    .post("/gate/okgo/deliveryManInfo", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      // 레이어닫기
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          search_dlv_Maninfo(rootStore);
          return true;
        }
      }
    })
    .catch(err => {});
  return res;
}

// 주방 메모 조회
export function kitchens_list(rootStore) {
  const searchStore = rootStore.searchStore;
  let data = JSON.stringify({
    shopCd: searchStore.getShopCd,
  });

  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/requestMessage/kitchens", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          rootStore.settingStore.setKitchenRequestMemo(res.data.data);
          return true;
        }
      }
    })
    .catch(err => {});
}

// 주방 메모 등록
export function requestKitchenMemoRegister(rootStore, requestMemo) {
  const searchStore = rootStore.searchStore;
  let data = JSON.stringify({
    shopCd: searchStore.getShopCd,
    memoNm: requestMemo,
  });

  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/requestMessage/kitchens/register", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          kitchens_list(rootStore);
          return true;
        }
      }
    })
    .catch(err => {});
}

// 주방 메모 삭제
export async function requestKitchenMemoDelete(rootStore, memoCd) {
  const searchStore = rootStore.searchStore;
  let data = JSON.stringify({
    shopCd: searchStore.getShopCd,
    memoCd: memoCd,
  });

  const api = Fn_activeAxios(rootStore);
  let res = await api
    .post("/gate/okgo/requestMessage/kitchens/delete", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          rootStore.settingStore.delKitchenRequestMemo();
          return true;
        }
      }
    })
    .catch(err => {});
  return res;
}

// 고객 메모 조회
export function customer_list(rootStore) {
  const searchStore = rootStore.searchStore;
  let data = JSON.stringify({
    shopCd: searchStore.getShopCd,
  });

  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/requestMessage/shops", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          rootStore.settingStore.setCustomerRequestMemo(res.data.data);
          return true;
        }
      }
    })
    .catch(err => {});
}

// 고객요청 메모 등록
export function requestCustomerMemoRegister(rootStore, message) {
  const searchStore = rootStore.searchStore;
  let data = JSON.stringify({
    shopCd: searchStore.getShopCd,
    message: message,
  });

  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/requestMessage/shops/register", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          customer_list(rootStore);
          return true;
        }
      }
    })
    .catch(err => {});
}

// 고객요청 메모 삭제
export async function requestCustomerMemoDelete(rootStore, seq) {
  const searchStore = rootStore.searchStore;
  let data = JSON.stringify({
    shopCd: searchStore.getShopCd,
    seq: seq,
  });

  const api = Fn_activeAxios(rootStore);
  let res = await api
    .post("/gate/okgo/requestMessage/shops/delete", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          rootStore.settingStore.delCustomerRequestMemo();
          return true;
        }
      }
    })
    .catch(err => {});
  return res;
}

// 외부 프로그램 주문 자동 완료여부 값
export async function outAutoUpdate(rootStore) {
  let data = JSON.stringify(rootStore.settingStore.getSettingOutAutoProg);
  const api = Fn_activeAxios(rootStore);
  let res = await api
    .post("/gate/okgo/envSettings/shopInfos/configurations/channels", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          return true;
        }
      }
    })
    .catch(err => {});
  return res;
}

// 외부 프로그램 주문 자동 완료 사용하는 배달매장
export async function program_use_list(rootStore) {
  const searchStore = rootStore.searchStore;
  const api = Fn_activeAxios(rootStore);
  let res = await api
    .get("/gate/okgo/envSettings/shopInfos/configurations/channels/" + searchStore.getShopCd, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          rootStore.settingStore.setSettingOutAutoProg(res.data.data);
          return true;
        }
      }
    })
    .catch(err => {});
  return res;
}

// 유/무료 설정
export async function pay_free_yntype(rootStore) {
  const searchStore = rootStore.searchStore;
  const api = Fn_activeAxios(rootStore);
  let res = await api
    .get("/gate/okgo/subscriptions?shopCd=" + searchStore.getShopCd, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          rootStore.settingStore.setPayFreeType(res.data.data.paymentUseYn);

          if (res.data.data.paymentUseYn === "1") {
            fn_setKitchenPrinterFlag(rootStore, false);
          }

          if (rootStore.settingStore.getPrinterInfo.hookingFlag == "Y" && res.data.data.paymentUseYn == "0") {
            fn_setHookingFlag(rootStore, false);
          }

          rootStore.settingStore.setPayFreeList(res.data.data.useDeliveryResList);
          res.data.data.useDeliveryResList.map((element, index) => {
            if (element.mainUseYn == "Y") {
              rootStore.settingStore.setMainDlv(element.dcode);
            }
          });
          return true;
        }
      }
    })
    .catch(err => {});
  return res;
}

// 배달대행사 사용여부 값
export async function deliveryUseUpdate(rootStore, delvList) {
  const searchStore = rootStore.searchStore;

  const transformedList = delvList.map(item => ({
    tp: item.dumaspDeliveryCode, // dumaspDeliveryCode -> tp
    useYn: item.use_yn, // use_yn -> useYn
  }));

  const payload = {
    deliveryList: transformedList,
    shopCd: searchStore.getShopCd,
  };

  const api = Fn_activeAxios(rootStore);
  let res = await api
    .post("/gate/okgo/subscriptions", payload, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          search_dlv_store_info(rootStore);
          return true;
        }
      }
    })
    .catch(err => {});
  return res;
}

// 공지사항 목록
export async function notice_list(rootStore, pageNo) {
  const api = Fn_activeAxios(rootStore);
  let data = pageNo;
  let res = await api
    .get("/gate/okgo/notices/views?pageNo=" + data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          if (res.data.data.notices.length > 0) {
            rootStore.settingStore.setNoticeId(res.data.data.notices[0].id);
          }
          rootStore.settingStore.setNoticePagingInfo("currentPage", res.data.data.currentPage);
          rootStore.settingStore.setNoticePagingInfo("maxPage", res.data.data.maxPage);
          rootStore.settingStore.setNoticeList(res.data.data.notices);
          fn_detailNoticeList(rootStore);
          fn_newNoticeList(rootStore);
          return true;
        }
      }
    })
    .catch(err => {});
  return res;
}

// 긴급공지 팝업
export async function emergency_notice(rootStore) {
  const searchStore = rootStore.searchStore;
  const api = Fn_activeAxios(rootStore);

  const res = await api
    .get("/gate/okgo/notices/emergency/" + searchStore.getShopCd, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          rootStore.settingStore.setSettingOutAutoProg(res.data.data);
          return true;
        }
      }
    })
    .catch(err => {});
  return res;
}

export async function shop_encryption(rootStore) {
  const searchStore = rootStore.searchStore;

  try {
    const api = Fn_activeAxios(rootStore);
    const res = await api.get("/gate/okgo/shop/connectinfo/" + searchStore.getShopCd, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    });
    if (res.data?.resultCode === "000") {
      const data = res.data?.data;
      rootStore.settingStore.setShopApiSetting(data);
    }
  } catch (error) {
    console.error("shop_encryption error", error);
  }
}

//설정정보 조회
export async function fn_setting_config(rootStore, type) {
  const api = Fn_activeAxios(rootStore);
  let res = await api
    .get("/gate/okgo/configs/" + rootStore.searchStore.getShopCd + "/" + rootStore.searchStore.getPosNo, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          if (IsJsonString(res.data.data)) {
            let data = JSON.parse(res.data.data);
            if (rootStore.settingStore.getInitView == "N" || data != null) {
              //재설치일때
              select_shop_setting_api(rootStore, data, type);
            }
          }
          return true;
        }
      }
    })
    .catch(err => {});
  return res;
}

// Agent 사용여부
export async function fn_shop_info(rootStore) {
  const searchStore = rootStore.searchStore;
  const api = Fn_activeAxios(rootStore);
  let response = await api
    .get("/gate/okgo/shopInfos/" + searchStore.getShopCd, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          let data = res.data.data;
          rootStore.settingStore.setBaeminUseStatus("isCurrentPosBaeminUse", data.isCurrentShopBaeminUse);
          rootStore.settingStore.setBaeminUseStatus("baeminUsePosNo", data.baeminUsePosNo);
          rootStore.settingStore.setYgyUseStatus(data.yogiyoYn);

          localStorage.setItem("isCurrentPosBaeminUse", data.isCurrentShopBaeminUse);
          localStorage.setItem("baeminUsePosNo", data.baeminUsePosNo);

          return true;
        }
      }
    })
    .catch(err => {});
  return response;
}

// 영수증 설정 조회
export async function fn_setting_prit_receipt(rootStore, type, val) {
  const searchStore = rootStore.searchStore;
  let shopCd = val == "DEFAULT" ? "DEFAULT" : searchStore.getShopCd;

  const api = Fn_activeAxios(rootStore);
  let res = await api
    .get("/gate/okgo/receipt-configs/" + shopCd + "/COMMON/" + type, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          let data = res.data.data;
          let list = [];

          if (type == "HALL") {
            rootStore.settingStore.setPrintOutListHall(data.configs);
            list = rootStore.settingStore.getPrintOutListHall;
            list.map((obj, index) => {
              if (obj.receiptModule == "HEADER") {
                rootStore.settingStore.setPrintOutReceipt0("title", obj.receiptStyle.title);
                rootStore.settingStore.setPrintOutReceipt0("channelNo", obj.receiptStyle.channelNo);
                rootStore.settingStore.setPrintOutReceipt0("posNo", obj.receiptStyle.posNo);
              } else if (obj.receiptModule == "DELIVERY_ADDRESS") {
                rootStore.settingStore.setPrintOutReceipt0("loadAdr", obj.receiptStyle.loadAdr);
                rootStore.settingStore.setPrintOutReceipt0("adress", obj.receiptStyle.adress);
                rootStore.settingStore.setPrintOutReceipt0("customerNm", obj.receiptStyle.customerNm);
              } else if (obj.receiptModule == "TEL_NO") {
                rootStore.settingStore.setPrintOutReceipt0("phone", obj.receiptStyle.phone);
              } else if (obj.receiptModule == "REQ_MESSAGE") {
                rootStore.settingStore.setPrintOutReceipt0("memo", obj.receiptStyle.memo);
              } else if (obj.receiptModule == "MENU") {
                rootStore.settingStore.setPrintOutReceipt0("menu", obj.receiptStyle.menu);
                rootStore.settingStore.setPrintOutReceipt0("option", obj.receiptStyle.option);
              } else if (obj.receiptModule == "TOTAL_AMOUNT") {
                rootStore.settingStore.setPrintOutReceipt0("payMethod", obj.receiptStyle.payMethod);
              } else if (obj.receiptModule == "ORDER_INFO") {
                rootStore.settingStore.setPrintOutReceipt0("shopNm", obj.receiptStyle.shopNm);
                rootStore.settingStore.setPrintOutReceipt0("orderTime", obj.receiptStyle.orderTime);
              }
            });
          } else if (type == "KITCHEN") {
            rootStore.settingStore.setPrintOutListKitchen(data.configs);
            list = rootStore.settingStore.getPrintOutListKitchen;
            list.map((obj, index) => {
              if (obj.receiptModule == "HEADER") {
                rootStore.settingStore.setPrintOutReceipt1("title", obj.receiptStyle.title);
                rootStore.settingStore.setPrintOutReceipt1("channelNo", obj.receiptStyle.channelNo);
                rootStore.settingStore.setPrintOutReceipt1("posNo", obj.receiptStyle.posNo);
              } else if (obj.receiptModule == "REQ_MESSAGE") {
                rootStore.settingStore.setPrintOutReceipt1("memo", obj.receiptStyle.memo);
              } else if (obj.receiptModule == "MENU") {
                rootStore.settingStore.setPrintOutReceipt1("menu", obj.receiptStyle.menu);
                rootStore.settingStore.setPrintOutReceipt1("option", obj.receiptStyle.option);
              } else if (obj.receiptModule == "ORDER_INFO") {
                rootStore.settingStore.setPrintOutReceipt1("shopNm", obj.receiptStyle.shopNm);
                rootStore.settingStore.setPrintOutReceipt1("orderTime", obj.receiptStyle.orderTime);
              }
            });
          }

          return res;
        }
      }
    })
    .catch(err => {});
}

// 영수증 설정 변경
export function fn_change_prit_receipt(rootStore, arr) {
  const searchStore = rootStore.searchStore;

  let data = JSON.stringify({
    shopCd: searchStore.getShopCd,
    configs: arr,
  });

  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/receipt-configs", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
        }
      }
    })
    .catch(err => {});
}

// 미처리 주문 알람 조회
export function fn_return_fail(rootStore) {
  const searchStore = rootStore.searchStore;
  const api = Fn_activeAxios(rootStore);
  api
    .get("/gate/okgo/alarms/" + searchStore.getShopCd, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data.length != 0) {
            rootStore.layerStore.setReturnFailBtn(true);
            fn_bridge_text_notify(rootStore, "배달매니저를 확인해주세요", "반품필요", "취소");
          } else {
            fn_setReturnListInit(rootStore);
            rootStore.layerStore.setReturnFailBtn(false);
          }
          rootStore.settingStore.setReturnFailList(data);
        }
      }
    })
    .catch(err => {});
}

// 미처리 주문 refund 성공시
export function fn_return_success(rootStore, no) {
  const searchStore = rootStore.searchStore;
  let data = JSON.stringify({
    pendingNo: no,
  });
  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/alarms/" + searchStore.getShopCd, data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data) {
            fn_return_fail(rootStore); //미처리 주문 알람 조회
          }
        } else {
          rootStore.layerStore.setLayerAlertType("fail");
          rootStore.layerStore.setLayerAlertView(true);
        }
      }
    })
    .catch(err => {});
}

// 매장 휴무 여부 조회
export async function fn_agency_holiday_search(rootStore) {
  const searchStore = rootStore.searchStore;
  let type = "YGY";
  const api = Fn_activeAxios(rootStore);
  let res = await api
    .get("/gate/agency/shops/" + searchStore.getShopCd + "/" + type + "/close", {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          rootStore.settingStore.setAgencyHolidayState(data.isAgencyShopClose);
          if (
            localStorage.getItem("holidayPop") != "hide" &&
            rootStore.settingStore.getAgencyHolidayState &&
            rootStore.settingStore.getMainPosType == "Y"
          ) {
            fn_ygy_holiday_setting(rootStore);
          }
        }
      }
    })
    .catch(err => {});
  return true;
}

// 매장 휴무 여부 변경
export function fn_agency_holiday_change(rootStore) {
  const searchStore = rootStore.searchStore;
  let type = "YGY";
  let data = JSON.stringify({
    isAgencyShopCloseRequest: !rootStore.settingStore.getAgencyHolidayState,
  });
  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/agency/shops/" + searchStore.getShopCd + "/" + type + "/close", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data) {
            fn_agency_holiday_search(rootStore); //에이전시 매장 휴무 여부 조회
          }
        }
      }
    })
    .catch(err => {});
}

function IsJsonString(str) {
  try {
    var json = JSON.parse(str);
    return typeof json === "object";
  } catch (e) {
    return false;
  }
}
